(function (window, $) {
  const buttons = {
    init: function () {
      $('body').on('mousedown touchstart', '.btn--raised:not(.btn--no-ripple)', function (e) {
        const rect = this.getBoundingClientRect();
        const rippleHeight = this.clientHeight * 1.25;
        const relX = e.pageX - rect.left - rippleHeight / 2;
        const relY = e.pageY - rect.top - window.pageYOffset - rippleHeight / 2;

        let ripple = document.createElement('div');
        ripple.className = 'btn--ripple';
        ripple.style.height = ripple.style.width = rippleHeight + 'px';
        ripple.style.top = relY + 'px';
        ripple.style.left = relX + 'px';
        ripple.style.transform = 'scale(0)';
        this.appendChild(ripple);

        gsap.to(ripple, 0.25, { scale: 1, ease: Power2.easeOut });
      });

      $('body').on('mouseup touchend', '.btn--raised', function (e) {
        const ripple = this.querySelectorAll('.btn--ripple');

        if (ripple) {
          setTimeout(() => {
            gsap.to(ripple, 0.5, {
              opacity: 0,
              ease: Power2.easeOut,
              onComplete: function () {
                ripple.forEach((ripple) => ripple._remove());
              },
            });
          }, 150);
        }
      });

      this.toggleFigcaption();
    },

    toggleFigcaption: function () {
      $('body').on('click', '.figure__figcaption-toggle', (e) => {
        const parent = e.target.closest('.figure');

        parent.querySelector('.figure__figcaption-toggle').setAttribute('disabled', '');
        parent
          .querySelector('.figure__figcaption')
          ._slideToggle()
          .then(() => {
            parent.querySelector('.figure__figcaption-toggle').removeAttribute('disabled');
          });
        parent.querySelectorAll('.figure__figcaption-toggle i')?.forEach((icon) => icon._toggle(0));
      });
    },
  };

  $(document).ready(function () {
    buttons.init();
  });
})(window, jQuery);
